import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import warning from 'warning';
import history from '../history';
import { Router } from 'react-router-dom';

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  var _super = _createSuper(MemoryRouter);

  function MemoryRouter(props) {
    var _this;

    _classCallCheck(this, MemoryRouter);

    _this = _super.call(this, props);
    warning(!('history' in props), "<MemoryRouter> ignore la prop. `history`. Pour utiliser un historique \"custom\", " + "utilisez `import { Router }` \xE0 la place de `import { MemoryRouter as Router }`.");
    var initialEntries = props.initialEntries,
        initialIndex = props.initialIndex,
        getUserConfirmation = props.getUserConfirmation,
        keyLength = props.keyLength;
    history.setup('memory', {
      initialEntries: initialEntries,
      initialIndex: initialIndex,
      getUserConfirmation: getUserConfirmation,
      keyLength: keyLength
    });
    return _this;
  }

  _createClass(MemoryRouter, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement(Router, {
        history: history.getInstance()
      }, children);
    }
  }]);

  return MemoryRouter;
}(React.Component);

MemoryRouter.defaultProps = {
  initialEntries: undefined,
  initialIndex: undefined,
  getUserConfirmation: undefined,
  keyLength: undefined,
  children: undefined
};
export default MemoryRouter;